export const mockAmplify = {
  async configure(config: Record<string, unknown>) {
    await new Promise((resolve) => setTimeout(resolve, 500))
    console.log('Mock Amplify: Configuration received', config)
  },
}
